module.exports = __webpack_public_path__ + "img/pc_p3_y5.95c95bed.png";